import React, {useState} from 'react'
import {Row, Col, Button, Modal} from 'react-bootstrap';

export const ProjectModal = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
		setShow(false);
	};

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row style={{backgroundColor: 'var(--blue)', padding: '20px'}}>
          <Col className="text-center white">
            <h2>¿Iniciativa estudiantil?</h2>
            <p>Registra tu proyecto <a href='/inscribir-proyecto'>aquí.</a></p>
          </Col>
        </Row>
        <Row style={{backgroundColor: 'var(--red)', padding: '20px'}}>
          <Col className="text-center white">
            <h2>¿Emprendimiento?</h2>
            <p>Mándanos un mensaje y recibe acompañamiento personalizado <a href='/conocenos#contacto' onClick={handleClose}>aqui.</a></p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="fablab-button" onClick={handleClose}>
        Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
